import {
  ABILITY_CATEGORY_WHEEL,
  ABILITY_CATEGORY_WHEELS,
  ABILITY_COUNT_WHEEL,
  RANK_THRESHOLDS,
  Wheel,
  WheelOption,
  getAbilityCount,
} from "@/data/wheels";

export function spinWheel(wheel: Wheel): WheelOption {
  const index = Math.floor(Math.random() * wheel.options.length);
  return wheel.options[index];
}

// Picks an option respecting each option's `weight` (falls back to an even
// chance for any option missing a weight).
export function spinWeightedWheel(wheel: Wheel): WheelOption {
  const weights = wheel.options.map((o) => o.weight ?? 1);
  const total = weights.reduce((sum, w) => sum + w, 0);
  let roll = Math.random() * total;
  for (let i = 0; i < wheel.options.length; i++) {
    roll -= weights[i];
    if (roll < 0) return wheel.options[i];
  }
  return wheel.options[wheel.options.length - 1];
}

export interface AbilityResult {
  category: WheelOption;
  ability: WheelOption;
}

// Spins the ability count wheel, then for each ability spins a weighted
// category and a result within that category.
export function spinAbilitySequence(): {
  count: WheelOption;
  abilities: AbilityResult[];
} {
  const count = spinWheel(ABILITY_COUNT_WHEEL);
  const total = getAbilityCount(count.name);
  const abilities: AbilityResult[] = [];
  for (let i = 0; i < total; i++) {
    const category = spinWeightedWheel(ABILITY_CATEGORY_WHEEL);
    const categoryWheel = ABILITY_CATEGORY_WHEELS[category.name];
    const ability = spinWheel(categoryWheel);
    abilities.push({ category, ability });
  }
  return { count, abilities };
}

export function calculateRank(score: number): string {
  for (const threshold of RANK_THRESHOLDS) {
    if (score >= threshold.min) {
      return threshold.label;
    }
  }
  return RANK_THRESHOLDS[RANK_THRESHOLDS.length - 1].label;
}

export function calculateTotalScore(results: WheelOption[]): number {
  return results.reduce((total, result) => total + result.value, 0);
}

export type Alignment = "Hero" | "Villain";
export type LeaderboardBoard = "hero" | "villain";

export function getLeaderboardBoard(
  alignment: Alignment | null,
): LeaderboardBoard | null {
  if (!alignment) return null;
  return alignment === "Hero" ? "hero" : "villain";
}
